import React, { useEffect, useState } from "react";
import "./WhyBrigiz.css";
import { getReviews } from "../../API/ApiService";
import { useDispatch, useSelector } from "react-redux";
import { loadingAction } from "../../Redux/Action/loadingAction";
import { useNavigate } from "react-router";
import { getItemLocalStorage } from "../../Utils/localStroge";
import { BUSINESS_TYPE_SIGN_IN } from "../../Utils/constants";
import { openAlert } from "../../Redux/Action/AlertPopUpAction/AlertPopUpAction";
import Arrow from "../../Component/arrow/Arrow";
import { WHY_BRIGIZ } from "../../Routes/RoutesConstant";

const faqs = [
  {
    id: 1,
    question: "What is Brigiz and how does it help my business?",
    answer:
      "Brigiz is a platform that connects businesses with local customers, helping you streamline operations, engage more customers, and grow your brand. From managing business details to tracking customer interactions, Brigiz provides the tools you need to succeed.",
  },
  {
    id: 2,
    question: "Is Brigiz suitable for all types of businesses?",
    answer:
      "Yes! Whether you run a restaurant, a retail store, a service-based business, or any other local enterprise, Brigiz helps you reach more customers and manage your business efficiently.",
  },
  {
    id: 3,
    question: "How can Brigiz help increase my sales?",
    answer:
      "Brigiz allows you to promote your business, offer special deals, and engage customers with personalized services. With better visibility and marketing tools, you can attract more customers and boost sales.",
  },

];

const WhyBrigiz = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { loginDataSuccess } = useSelector((state) => state.LoginData);
  const { userBusinessDetails } = useSelector((state) => state.businessData);
  const isLoggedIn = loginDataSuccess?.access_token && loginDataSuccess?.result;
  const loginData = loginDataSuccess?.result;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reviews, setData] = useState([]);
  const slidesToShow = 3;

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  const [openIds, setOpenIds] = useState([1]);

  const toggleFAQ = (id) => {
    setOpenIds((prevIds) =>
      prevIds.includes(id)
        ? prevIds.filter((openId) => openId !== id)
        : [...prevIds, id]
    );
  };
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    const obj = {
      page: 1,
      limit: 3,
    };
    dispatch(loadingAction(true));
    getReviews(obj)
      .then((res) => {
        setData(res?.data?.result?.rows);
        dispatch(loadingAction(false));
      })
      .catch((err) => {
        dispatch(loadingAction(false));
      });
  };

  const checkLoggedIn = () => {
    if (isLoggedIn) {
      if (loginData.user_state === "0") {
        navigate("/register", { state: { backRoute: WHY_BRIGIZ } });
      } else {
        const getSignedInType = getItemLocalStorage("sign_in_type");
        if (getSignedInType === BUSINESS_TYPE_SIGN_IN) {
          if (!userBusinessDetails || !userBusinessDetails.id) {
            navigate("/adbusinessdetails", {
              state: { backRoute: WHY_BRIGIZ },
            });
          } else {
            const businessId = getItemLocalStorage("id");
            const businessName = getItemLocalStorage("businessName");
            if (businessId && businessName) {
              navigate(
                `/businessDetails/${businessId}?name=${businessName
                  ?.trim()
                  ?.replaceAll(" ", "_")}`,
                { state: { businessId } }
              );
            } else {
              navigate("/");
            }
          }
        } else {
          dispatch(openAlert());
        }
      }
    } else {
      navigate("/signin", {
        state: { checkedVal: BUSINESS_TYPE_SIGN_IN, backRoute: WHY_BRIGIZ },
      });
    }
  };

  return (
    <div className="why-brigiz">
      <div className="homepage ">
        <div className="container">
          {/* Top Section */}
          <div className="top-section px-1">
            {/* Left Content */}
            <div className="left-content">
              <h1>
                Streamline Operations, Engage Customers, and{" "}
                <span className="boost">Boost Sales!</span>
              </h1>
              <p>
                Everything you need to manage, grow, and scale your business in
                one platform.
              </p>
              <button
                onClick={() => {
                  checkLoggedIn();
                }}
                className="get-started"
              >
                Get Started
              </button>
            </div>

            {/* Right Image */}
            <div className="right-image">
              <img src="/images/Mobile copy.png" alt="Mobile App" />
            </div>
          </div>
        </div>
      </div>

      {/* why join us */}
      <div className="container2">
        <div className="why-join-section">
          <h2>
            Why
            <span className="boost"> Join Us?</span>
          </h2>
          <p>
            Take control of your business with a seamless and user-friendly
            platform designed to simplify operations, enhance customer
            engagement, and expand your brand both locally and globally. Whether
            you’re setting up your business details, managing services, or
            tracking customer interactions, Brigiz provides all the tools you
            need to streamline processes and drive success. Our platform
            empowers you to connect with your audience, improve efficiency, and
            unlock new opportunities for growth. No matter the size of your
            business, we help you stay ahead in a competitive marketplace with
            smart solutions tailored to your needs.
          </p>
        </div>
        <div className="device-images ">
          <img
            src="/images/macBook1.png"
            alt="Macbook"
            className="macbook-image "
          />
          <img
            src="/images/mobile_why_brigiz.png"
            alt="Mobile App"
            className="mobile-image "
          />
        </div>
      </div>

      {/* Key Feature and benefit */}
      <div className="container3">
        <h1 className="key-features-title">
          Key Features
          <span className="boost"> & Benefits</span>
        </h1>

        {/* Business Setup Row */}

        <div className="feature-row">
          <div className="feature-content">
            <h3>Business Setup & Management</h3>
            <ul>
              <li>
                <img
                  src="/images/register_business.png"
                  alt="Register"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">
                    Register Your Business:
                  </strong>{" "}
                  Add essential details like name, address, phone number,
                  website, and social accounts to create your digital presence.
                </div>
              </li>
              <li>
                <img
                  src="/images/working_hour.png"
                  alt="Hours"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">Set Working Hours:</strong>{" "}
                  Customize availability slots for different days and mark
                  holidays in one click.
                </div>
              </li>
              <li>
                <img
                  src="/images/product_services.png"
                  alt="Products"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">
                    Add Products & Services:
                  </strong>{" "}
                  List and sell your offerings online effortlessly to start
                  earning immediately.
                </div>
              </li>
            </ul>
          </div>
          <div className="feature-image">
            <img src="/images/bussiness_setup.png" alt="Business Setup" />
          </div>
        </div>

        {/* Customer Engagement Row */}
        <div className="feature-row reverse">
          <div className="feature-content">
            <h3>Customer Engagement & Marketing</h3>
            <ul>
              <li>
                <img
                  src="/images/register_business.png"
                  alt="Customer"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">
                    Customer Interaction:
                  </strong>{" "}
                  Engage with your audience through your business account and
                  build lasting relationships.
                </div>
              </li>
              <li>
                <img
                  src="/images/events_why.png"
                  alt="Events"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">
                    Events & Initiatives:
                  </strong>{" "}
                  Host events and invite customers to participate in special
                  promotions.
                </div>
              </li>
              <li>
                <img
                  src="/images/sale_why.png"
                  alt="Social"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">
                    Sales And promotions:
                  </strong>{" "}
                  Offer special discounts and deals to attract more customers.
                </div>
              </li>
              <li>
                <img
                  src="/images/announcement_why.png"
                  alt="Social"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">Announcements:</strong> Keep
                  customers informed with important business updates.
                </div>
              </li>
              <li>
                <img src="/images/offer.png" alt="" className="feature-icon" />
                <div className="feature-text">
                  <strong className="feature-title">Offers & Discounts:</strong>{" "}
                  Create exclusive offers to boost customer engagement.
                </div>
              </li>
            </ul>
          </div>
          <div className="feature-image">
            <img
              src="/images/customer_engagement.png"
              alt="Customer Engagement"
            />
          </div>
        </div>

        {/* Properties Showcase Row */}
        <div className="feature-row">
          <div className="feature-content">
            <h3>Showcase Your Properties</h3>
            <ul>
              <li>
                <img
                  src="/images/property.png"
                  alt=""
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">
                    showcase Your Properties:
                  </strong>{" "}
                  List properties in the Realtor market and connect with
                  potential buyers or renters.
                </div>
              </li>
            </ul>
          </div>
          <div className="feature-image">
            <img src="/images/showcase.png" alt="Properties Showcase" />
          </div>
        </div>

        {/*Customer Feedback and Analysis*/}
        <div className="feature-row reverse">
          <div className="feature-content">
            <h3>Customer Feedback and Analytics</h3>
            <ul>
              <li>
                <img
                  src="/images/customer_review.png"
                  alt="Feedback"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">Customer Reviews:</strong>{" "}
                  Get direct feedback from your customers to improve your
                  services.
                </div>
              </li>
              <li>
                <img
                  src="/images/favorite_count.png"
                  alt="Analytics"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">Favorites Count:</strong>{" "}
                  Track how many cutomers have marked your business as their
                  favorite.
                </div>
              </li>
              <li>
                <img
                  src="/images/analytiscs.png"
                  alt="Reports"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">
                    Analytics & Insights:
                  </strong>{" "}
                  Monitor engagement data weeekly, monthly, and yearly to
                  optimize business strategies.
                </div>
              </li>
            </ul>
          </div>
          <div className="feature-image">
            <img src="/images/customer_feedback.png" alt="Customer Feedback" />
          </div>
        </div>

        {/* payment Your Properties */}
        <div className="feature-row">
          <div className="feature-content">
            <h3>Payments and Transactions</h3>
            <ul>
              <li>
                <img
                  src="/images/instant_payment.png"
                  alt="Browse"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">Instant Payments:</strong>{" "}
                  Add your preferred payment method and generate invoice
                  seamlessly
                </div>
              </li>
              <li>
                <img
                  src="/images/customer_management.png"
                  alt="Browse"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">
                    Customer Management:
                  </strong>{" "}
                  Acess customer transactions history, send messages, and make
                  calls directly within the app.
                </div>
              </li>
              <li>
                <img
                  src="/images/notes_section.png"
                  alt="Browse"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">Notes Section:</strong> Save
                  essential business insights and reminders within the platform.
                </div>
              </li>
            </ul>
          </div>
          <div className="feature-image">
            <img src="/images/payment_big.png" alt="Properties Showcase" />
          </div>
        </div>
        <div className="feature-row reverse">
          <div className="feature-content">
            <h3>Advertising and Growth</h3>
            <ul>
              <li>
                <img
                  src="/images/boost_bussiness.png"
                  alt="Campaigns"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">
                    Boost Your Business Visibility:
                  </strong>{" "}
                  Advertise with tailored ad plans to reach a broader audience.
                </div>
              </li>
              <li>
                <img
                  src="/images/manage_ads.png"
                  alt="Growth"
                  className="feature-icon"
                />
                <div className="feature-text">
                  <strong className="feature-title">
                    Manage Ad Campaigns:
                  </strong>{" "}
                  Customize and track your ads for maximum impact.
                </div>
              </li>
            </ul>
          </div>
          <div className="feature-image">
            <img
              src="/images/advertising_growth.png"
              alt="Advertising and Growth"
            />
          </div>
        </div>
      </div>

      {/* How It Works Section */}
      <div className="how-it-works">
        <div className="how-it-works-header">
          <h1>
            How It Works{" "}
            <span className="highlight">(Step-by-Step Tutorial)</span>
          </h1>
          <p className="subtitle">
            Use a timeline or step-by-step layout to explain how the app works.
            Include visuals and screenshots for each step.
          </p>
        </div>

        <div className="steps-container">
          <div className="step-row">
            <div className="step-content">
              <div className="step-title">
                <span className="step-number">1.</span>
                <h3>Sign Up & Register Your Business</h3>
              </div>
              <p>
                Create an account and add your business details in a few simple
                steps.
              </p>
            </div>
            <div className="step-image">
              <img
                src="/images/ads_business_details_why_brigiz.png"
                alt="Sign Up Screen"
              />
            </div>

            <Arrow side="left" />
          </div>

          <div className="step-row reverse">
            <div className="step-content">
              <div className="step-title">
                <span className="step-number">2.</span>
                <h3>Set Up Your Profile</h3>
              </div>
              <p>
                Add working hours, products, services, and other key
                information.
              </p>
            </div>
            <div className="step-image">
              <img src="/images/setup_profile.png" alt="Profile Setup" />
            </div>
            <Arrow side="right" />
          </div>

          <div className="step-row">
            <div className="step-content">
              <div className="step-title">
                <span className="step-number">3.</span>
                <h3>Engage Customers</h3>
              </div>
              <p>
                Create events, sales, announcements, and offers to attract and
                retain customers.
              </p>
            </div>
            <div className="step-image">
              <img src="/images/postoffer.png" alt="Sign Up Screen" />
            </div>

            <Arrow side="left" />
          </div>
          <div className="step-row reverse">
            <div className="step-content">
              <div className="step-title">
                <span className="step-number">4.</span>
                <h3>Monitor & Grow</h3>
              </div>
              <p>
                Use analytics and Customer feedback to track performance make
                data-driven decisions.
              </p>
            </div>
            <div className="step-image">
              <img src="/images/monitor.png" alt="Profile Setup" />
            </div>
            <Arrow side="right" />
          </div>
          <div className="step-row">
            <div className="step-content">
              <div className="step-title">
                <span className="step-number">5.</span>
                <h3>Get Paid & Manage Customers</h3>
              </div>
              <p>
                Generate invoices, accept payments, and manage customer
                interactions seamlessly.
              </p>
            </div>
            <div className="step-image">
              <img src="/images/getpaid.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      {/* Benefits Section */}

      <div className="benefits-section">
        <div className="benefits-content-wrapper">
          {" "}
          {/* New wrapper div */}
          <h2 className="benefits-title">
            <span className="green-text">Benefits</span>Of Using Brigiz
          </h2>
          <div className="benefits-container">
            <div className="benefits-list">
              <div className="benefit-item">
                <img src="/images/time.png" alt="" />
                <div className="benefit-text">
                  <span className="benefit-heading">Save Time:</span>
                  <span className="benefit-description">
                    Automate business operations and focus on what matters most
                    – growing your business.
                  </span>
                </div>
              </div>
              <div className="benefit-item">
                <img src="/images/revenue.png" alt="" />
                <div className="benefit-text">
                  <span className="benefit-heading">Increase Revenue:</span>
                  <span className="benefit-description">
                    Sell online, create offers, and attract more customers to
                    boost sales.
                  </span>
                </div>
              </div>
              <div className="benefit-item">
                <img src="/images/customer.png" alt="" />
                <div className="benefit-text">
                  <span className="benefit-heading">Customer Insights:</span>
                  <span className="benefit-description">
                    Understand your customers better with reviews, feedback, and
                    analytics.
                  </span>
                </div>
              </div>
              <div className="benefit-item">
                <img src="/images/flexibility.png" alt="" />
                <div className="benefit-text">
                  <span className="benefit-heading">Flexibility:</span>
                  <span className="benefit-description">
                    Set custom working hours, mark holidays, and manage your
                    business on your terms.
                  </span>
                </div>
              </div>
              <div className="benefit-item">
                <img src="/images/wider.png" alt="" />
                <div className="benefit-text">
                  <span className="benefit-heading">Wider Reach:</span>
                  <span className="benefit-description">
                    Advertise your business to reach a larger audience and grow
                    your customer base.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="phone-image">
          <img
            src="/images/benefits_why_brigiz.png"
            alt="Brigiz App Interface"
          />
        </div>
        {/* Discover yourself */}
        <div className="cta-section">
          <h2>Discover More with a Brigiz Account</h2>
          <button
            onClick={() => {
              isLoggedIn
                ? checkLoggedIn()
                : navigate("/register", {
                  state: { checkedVal: BUSINESS_TYPE_SIGN_IN },
                });
            }}
            className="sign-up-btn"
          >
            Sign Up
          </button>
        </div>
      </div>

      {/* Testimonials */}
      <div className="testimonials-section">
        <div className="testimonials-header">
          <h2>
            Testimonials & <span className="green-text">Reviews</span>
          </h2>
          <p style={{ color: "white" }}>
            See what users say about Brigiz! Real stories of businesses
            simplifying operations, engaging customers, and growing
            successfully.
          </p>
        </div>

        <div className="testimonials-container">
          {reviews
            .slice(
              currentSlide * slidesToShow,
              currentSlide * slidesToShow + slidesToShow
            )
            .map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="stars">
                  {[...Array(5)].map((_, index) => (
                    <svg
                      key={index}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill={index < testimonial.rating ? "#FFD700" : "#333"}
                    >
                      <path d="M10 1l2.5 6h6.5l-5 4.5 2 6.5-6-4.5-6 4.5 2-6.5-5-4.5h6.5z" />
                    </svg>
                  ))}
                </div>
                <h3>{testimonial.title}</h3>
                <p>{testimonial.review}</p>
                <div className="user-info">
                  <img src={testimonial.profile_image} alt={testimonial.name} />
                  <span>{testimonial.name}</span>
                </div>
              </div>
            ))}
        </div>
        {reviews.length > slidesToShow ? (
          <div className="dots">
            {[0, 1, 2].map((index) => (
              <button
                key={index}
                className={`dot ${currentSlide === index ? "active" : ""}`}
                onClick={() => handleDotClick(index)}
                aria-label={`Go to slide ${index + 1}`}
                style={{
                  background:
                    currentSlide === index
                      ? "#349C52"
                      : "rgba(255, 255, 255, 0.2)",
                }}
              />
            ))}
          </div>
        ) : (
          <div className="dots">
            {[...Array(reviews.length)].map(
              (
                _,
                index // Fixed the Array creation
              ) => (
                <button
                  key={index}
                  className={`dot ${currentSlide === index ? "active" : ""}`}
                  onClick={() => handleDotClick(index)}
                  aria-label={`Go to slide ${index + 1}`}
                  style={{
                    background:
                      currentSlide === index
                        ? "#349C52"
                        : "rgba(255, 255, 255, 0.2)",
                  }}
                />
              )
            )}
          </div>
        )}
      </div>

      {/* FAQ */}
      <div className="faq-wrapper">
        <div className="faq-section">
          <h2>FAQs</h2>
          <p className="faq-description">
            Find answers to common questions about Brigiz. Learn how our
            platform helps streamline operations, engage customers, and grow
            your business.
          </p>

          <div className="faq-container">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${openIds.includes(faq.id) ? "active" : ""
                  }`}
                onClick={() => toggleFAQ(faq.id)}
              >
                <div className="faq-question">
                  <h3>{faq.question}</h3>
                  <svg
                    className="expand-icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M7 10l5 5 5-5"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Manage Your Business */}
      {/* <div className="download-section">
        <div className="content-wrapper">
          <div className="text-content">
            <h1>
              Manage Your Business
              <br />
              Anytime, Anywhere
            </h1>

            <p>
              Download the Brigiz app to streamline your operations, connect
              with customers, and grow your business effortlessly. Manage your
              services, track customer interactions, and stay organized—all from
              your mobile.
            </p>

            <div className="download-buttons">
              <h3>Get the App</h3>
              <div className="store-buttons">
                <a href="#" className="play-store">
                  <img
                    src="/images/google_play_button.png"
                    alt="Get it on Google Play"
                  />
                </a>
                <a href="#" className="app-store">
                  <img
                    src="/images/app_store.png"
                    alt="Download on App Store"
                  />
                </a>
              </div>
            </div>
          </div>

          <div className="app-screenshots">
            <img
              src="/images/Phone Mockup 1.png"
              alt="Brigiz App Dashboard"
              className="screen-1"
            />
            <img
              src="/images/Phone Mockup 2.png"
              alt="Brigiz App Profile"
              className="screen-2"
            />
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default WhyBrigiz;
